import { useTranslation } from "react-i18next"; import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import DocumentationFeedback from './DocumentationFeedback';
import DocumentationButtons from './DocumentationButtons';
import DocumentationSearch from './DocumentationSearch';
import DocumentationCategories from './DocumentationCategories';

const DocumentationQuestionsWrapper = (props) => {

    if (props.about_wrapper === false) return <>{props.children}</>;

    return <div data-test-id="documentation-wr" className={"widget widget-documentation" + (props?.dark ? " bg-dark" : "")}>
        {props.children}
    </div>;
};

const DocumentationQuestions = (props) => {
    const { t } = useTranslation();
    const [content, setContent] = useState(null);
    const [search, setSearch] = useState('');

    return (
        <DocumentationQuestionsWrapper {...props}>
            <div className="container-xl row mx-auto p-0">
                <div className={"col-12 col-md-5" + (content === null ? "" : " d-none d-md-block")}>
                    <DocumentationSearch data={{ search: search, setSearch: setSearch, setContent: setContent }} dark={props?.dark} />
                    <DocumentationCategories data={{ search: search, content: content, setContent: setContent }} {...props} />
                </div>
                <div className="col-12 col-md-7">
                    <div>
                        {content !== null ?
                            <button
                                data-test-id="doc-item-back"
                                type="button"
                                onClick={() => setContent(null)}
                                className={"d-block d-md-none btn btn-back h-42 px-12 mx-auto mb-4" + (props?.dark ? " btn-dark" : "")}>{t("Back")}

                            </button> :
                            null}
                        <div data-test-id="doc-item-content" className={"editor" + (props?.dark ? " bg-dark" : "")} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}></div>
                        {content ? <DocumentationFeedback dark={props?.dark} /> : null}
                    </div>
                    <DocumentationButtons dark={props?.dark} />
                </div>
            </div>
        </DocumentationQuestionsWrapper>);

};

export default DocumentationQuestions;